import { inject, Injectable } from '@angular/core';
import { GeneralStore } from '@core/stores/general.store';
import { getState } from '@ngrx/signals';

@Injectable({
    providedIn: 'root',
})
export class GeneralStateService {
    readonly store = inject(GeneralStore);

    constructor() {}

    getGeneralState(id: string): any {
        return getState(this.store).state.get(id);
    }

    setGeneralState(id: string, value: any) {
        this.store.update(id, value);
    }
}
